export const defaultGiftCardPaymentFormData = {
    cardNumber: '',
    pin: ''
};
